import { c as _inherits, d as _getPrototypeOf, e as _possibleConstructorReturn, a as _classCallCheck, ac as _assertThisInitialized, _ as _createClass, ad as createPicsartText, p as getNodeAttrs, s as setNodeAttrs } from './selectors-f64b5778.js';
import { _ as _defineProperty } from './defineProperty-18999f8e.js';
import { t as tinycolor } from './tinycolor-c9a47691.js';
import { B as BaseLayer } from './base-a1755813.js';
import loadFont from './utils/loadFont/index.js';
import { TEXT_STROKE_RATIO } from './configs/index.js';
import getTextFill from './utils/getTextFill/index.js';
import { getLayerManipulations } from './external/index.js';
import getTextLayerDefaultAttrs from './defaults/text/index.js';
import getTransformedText from './utils/getTransformedText/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// TODO: Write unit and functional tests for CustomTextLayer class https://picsart.atlassian.net/browse/PIA-175373
var CustomTextLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(CustomTextLayer, _BaseLayer);

  var _super = _createSuper(CustomTextLayer);

  // arc angle in radians
  function CustomTextLayer(partialArgs) {
    var _this;

    _classCallCheck(this, CustomTextLayer);

    var args = _objectSpread(_objectSpread({}, getTextLayerDefaultAttrs()), partialArgs);

    _this = _super.call(this, args, ['text', 'textArr', 'fontFamily', 'fontSrc', 'fontSize', 'fontStyle', 'textDecoration', 'width', 'letterSpacing', 'lineHeight', 'align', 'verticalAlign', 'wrap', 'colorRGB1', 'colorRGB2', 'shadowTransparent', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'shadowOpacity', 'outlineColor', 'outlineSize', 'opacityOutline', 'outlineTransparent', 'textTransform', 'colorTransparent', 'colorOpacity', 'bend']);

    _defineProperty(_assertThisInitialized(_this), "textArr", []);

    _defineProperty(_assertThisInitialized(_this), "wrap", 'word');

    _defineProperty(_assertThisInitialized(_this), "storeSimpleTextWidth", 0);

    var text = args.text,
        fontFamily = args.fontFamily,
        fontSize = args.fontSize,
        fontStyle = args.fontStyle,
        textDecoration = args.textDecoration,
        width = args.width,
        letterSpacing = args.letterSpacing,
        lineHeight = args.lineHeight,
        align = args.align,
        verticalAlign = args.verticalAlign,
        wrap = args.wrap,
        fontSrc = args.fontSrc,
        colorRGB1 = args.colorRGB1,
        colorRGB2 = args.colorRGB2,
        shadowTransparent = args.shadowTransparent,
        shadowColor = args.shadowColor,
        shadowBlur = args.shadowBlur,
        shadowOffsetX = args.shadowOffsetX,
        shadowOffsetY = args.shadowOffsetY,
        shadowOpacity = args.shadowOpacity,
        outlineColor = args.outlineColor,
        outlineSize = args.outlineSize,
        opacityOutline = args.opacityOutline,
        outlineTransparent = args.outlineTransparent,
        textTransform = args.textTransform,
        colorTransparent = args.colorTransparent,
        colorOpacity = args.colorOpacity,
        _args$bend = args.bend,
        bend = _args$bend === void 0 ? 0 : _args$bend;
    _this.text = text;
    _this.fontFamily = fontFamily;
    _this.fontSrc = fontSrc;
    _this.fontSize = fontSize;
    _this.fontStyle = fontStyle;
    _this.textDecoration = textDecoration;
    _this.width = width;
    _this.letterSpacing = letterSpacing;
    _this.lineHeight = lineHeight;
    _this.align = align;
    _this.verticalAlign = verticalAlign;
    _this.wrap = wrap;
    _this.colorRGB1 = colorRGB1;
    _this.colorRGB2 = colorRGB2;
    _this.shadowColor = shadowColor;
    _this.shadowBlur = shadowBlur;
    _this.shadowOffsetX = shadowOffsetX;
    _this.shadowOffsetY = shadowOffsetY;
    _this.shadowOpacity = shadowOpacity;
    _this.outlineColor = outlineColor;
    _this.outlineSize = outlineSize;
    _this.opacityOutline = opacityOutline;
    _this.outlineTransparent = outlineTransparent;
    _this.textTransform = textTransform;
    _this.colorTransparent = colorTransparent;
    _this.shadowTransparent = shadowTransparent;
    _this.colorOpacity = colorOpacity; // we will keep scale of text element 1, instead we will change width or fontSize

    _this.scaleX = 1;
    _this.scaleY = 1;
    _this.bend = bend;

    _this.generate();

    return _this;
  }
  /* for some texts width is predifined, if width is 0 (which is set as default value in BaseLayer)
   we consider that width not set and let konva to decide the value */


  _createClass(CustomTextLayer, [{
    key: "generateRenderable",
    value: function generateRenderable() {
      var _this2 = this;

      var attrs = this._getData();

      this.innerRenderable = createPicsartText(_objectSpread(_objectSpread({}, attrs), {}, {
        x: this.x,
        y: this.y,
        rotation: this.rotation
      }));
      this.width = this.width || getNodeAttrs(this.innerRenderable).width;
      this.height = this.innerRenderable.getTextHeight();
      this.readyToRender = true;
      this.textArr = this.innerRenderable.textArr;
      setNodeAttrs(this.innerRenderable, {
        width: this.width
      }); // HACK
      // since we need to have text height in store, and we are not doing calculations, we'll update its value based on renderer engine(konva for now) calculations
      // Height can be calculated based on other metrics (fontsize lineHeight, letterSpace, width etc.) and it's not mandatory to keep in store.

      var _getLayerManipulation = getLayerManipulations(),
          updateLayer = _getLayerManipulation.updateLayer;

      updateLayer === null || updateLayer === void 0 ? void 0 : updateLayer(this.id, {
        height: this.height,
        width: this.width,
        textArr: this.textArr
      });

      if (this.fontSrc) {
        loadFont(this.fontFamily, this.fontSrc).then(function () {
          _this2.eventTarget.dispatchEvent(_this2.readyEvent);
        });
      } else {
        this.eventTarget.dispatchEvent(this.readyEvent);
      }
    }
  }, {
    key: "updateRenderable",
    value: function updateRenderable(keys) {
      var attrs = this._getData();

      setNodeAttrs(this.innerRenderable, attrs);
      var updateWidth = this.needToUpdateWidth(keys);

      var _this$innerRenderable = this.innerRenderable.getTextBoundingBox(),
          width = _this$innerRenderable.width;

      var _this$innerRenderable2 = this.innerRenderable.getTextBoundingBox(),
          height = _this$innerRenderable2.height;

      this.textArr = this.innerRenderable.textArr;

      if (updateWidth) {
        if (this.bend) {
          this.storeSimpleTextWidth = this.storeSimpleTextWidth || this.width;
        } else {
          width = this.storeSimpleTextWidth;
          this.storeSimpleTextWidth = 0;
        }
      } // HACK
      // since we need to have text height and width (in case of bend) in store, and we are not doing calculations, we'll update its value based on renderer engine(konva for now) calculations
      // Height can be calculated based on other metrics (fontsize lineHeight, letterSpace, width etc.) and it's not mandatory to keep in store.


      var _getLayerManipulation2 = getLayerManipulations(),
          updateLayer = _getLayerManipulation2.updateLayer;

      var patch = _objectSpread({
        height: height,
        textArr: this.textArr
      }, updateWidth && {
        width: width
      });

      updateLayer(this.id, patch);
    }
  }, {
    key: "needToUpdateWidth",
    value: function needToUpdateWidth(keys) {
      if (keys.includes('bend')) return true;

      if (this.bend) {
        return ['letterSpacing', 'fontFamily', 'text'].some(function (fieldThatAffectsWidth) {
          return keys.includes(fieldThatAffectsWidth);
        });
      }

      return false;
    }
  }, {
    key: "_getData",
    value: function _getData() {
      return {
        id: this.id,
        fill: this.getFill(),
        text: getTransformedText(this.textTransform, this.text),
        wrap: this.wrap,
        align: this.align,
        bend: this.bend,
        fontSize: this.fontSize,
        fontStyle: this.fontStyle,
        lineHeight: this.lineHeight,
        fontFamily: this.fontFamily,
        listening: this.interactable,
        width: this.width || undefined,
        verticalAlign: this.verticalAlign,
        letterSpacing: this.letterSpacing,
        stroke: this.getOutLine(),
        shadowOffsetX: this.shadowOffsetX,
        shadowOffsetY: this.shadowOffsetY,
        shadowColor: this.getShadowColor(),
        fillAfterStrokeEnabled: true,
        lineJoin: 'round',
        globalCompositeOperation: this.globalCompositeOperation,
        textDecoration: this.textDecoration,
        visible: this.visible,
        height: undefined,
        shadowBlur: this.shadowBlur && this.shadowBlur / 5,
        shadowOpacity: this.shadowOpacity && this.shadowOpacity / 100,
        draggable: !getNodeAttrs(this.outerRenderable).draggable && this.draggable,
        strokeWidth: this.outlineSize ? this.outlineSize * this.fontSize * TEXT_STROKE_RATIO / 100 : 0
      };
    }
  }, {
    key: "getFill",
    value: function getFill() {
      return getTextFill({
        colorRGB1: this.colorRGB1,
        colorOpacity: this.colorOpacity,
        colorTransparent: this.colorTransparent
      });
    }
  }, {
    key: "getOutLine",
    value: function getOutLine() {
      if (this.outlineColor) {
        return tinycolor(this.outlineColor).setAlpha(this.outlineTransparent ? 0 : this.opacityOutline !== undefined ? this.opacityOutline / 100 : this.outlineColor.a || 100).toRgbString();
      }
    }
  }, {
    key: "getShadowColor",
    value: function getShadowColor() {
      if (!this.shadowColor || this.shadowTransparent) {
        return tinycolor({
          r: 1,
          g: 1,
          b: 1,
          a: 0
        }).toRgbString();
      }

      return tinycolor(this.shadowColor).toRgbString();
    }
  }]);

  return CustomTextLayer;
}(BaseLayer);

var getTextTopLeftPosition = function getTextTopLeftPosition(layerProvider, layerId) {
  if (!layerId) return;
  var layer = layerProvider.getLayer(layerId);

  if (layer instanceof CustomTextLayer) {
    return {
      x: layer.x - layer.width / 2,
      y: layer.y - layer.height / 2
    };
  }
};

export { CustomTextLayer as C, getTextTopLeftPosition as g };
